import React, { useContext, useMemo, useState } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { App, Button, Card, Col, Divider, Empty, Grid, Menu, Row, Typography } from 'antd';
import { AppstoreOutlined, MailOutlined, FileDoneOutlined } from "@ant-design/icons";

import { useRelativePath } from '@/Hooks/useNextRelativePath';
import { EnumTipoUsuario } from '@/Models/Domain/AreaRestrita/Sessao';
import { TypeAluno } from '@/Models/Domain/Pessoa/Aluno';
import { CadastroDeResponsavel } from '@/Views/Viagem/Cadastros/Viagem/Componentes/CadastroDeResponsavel';
import { PropriedadesDeNotificacao } from '@/Utils/Notificacoes';

import { FichaDeSaudeDoAluno } from '../Saude/Ficha/FichaDeSaudeDoAluno';
import { SessaoARContext } from '../../Contexts/SessaoContext';
import { useSelecionarAluno } from '../SelecaoDeAluno';
import AlunosScreen from './AlunosScreen';

const DadosCadastraisParaTipoResponsavel: React.FC<{
}> = (props) => {
    const { notification } = App.useApp();

    const breakpoint = Grid.useBreakpoint();

    const SessaoAR = useContext(SessaoARContext);
    const navigate = useNavigate()

    const [, subrota] = useRelativePath()

    const informacoesDoResponsavel = useMemo(() => {
         return SessaoAR?.sessao?.info 
    }, [])

    const [ alunoSelecionado, setAlunoSelecionado ] = useState<TypeAluno>()
    const selecionarAluno = useSelecionarAluno()

    if (SessaoAR?.sessao?.tipoDeUsuario !== EnumTipoUsuario.Responsavel) return <Empty description="A sessão atual não corresponde a uma sessão do tipo responsável"/>;

    return (
        <Row style={{ height: "100%" }} gutter={[16, 0]}>
            <Col style={{ height: breakpoint.lg ? "100%" : undefined }} xs={!breakpoint.lg ? 24 : 4}>
                <Menu
                    items={[
                        { key: "responsavel", label: "Responsável", icon: <MailOutlined /> },
                        { key: "alunos", label: "Alunos", icon: <AppstoreOutlined /> },
                        { key: "ficha-de-saude", label: "Ficha de saúde", icon: <FileDoneOutlined /> },
                    ]}
                    onClick={(e) => {
                        navigate(e.key);
                    }}
                    style={{ height: breakpoint.lg ? "100%" : undefined }}
                    defaultSelectedKeys={[subrota.replace(/^\//, "")]}
                    mode={breakpoint.lg == undefined || breakpoint.lg ? "vertical" : "horizontal"}
                />
            </Col>

            <Col lg={20} xs={24}>
                <Routes>
                    <Route
                        key="responsavel"
                        path="/responsavel"
                        element={
                            <Card style={{ height: "100%" }}>
                                {informacoesDoResponsavel == undefined ? (
                                    <Empty description="Ocorreu um erro inesperado" />
                                ) : (
                                    <React.Fragment>
                                        <Typography.Title level={4} style={{ marginTop: 0 }}>
                                            Informações do responsável
                                            <Divider />
                                        </Typography.Title>
                                        <CadastroDeResponsavel
                                            responsavelEmAlteracao={informacoesDoResponsavel}
                                            middleware={(v, f) => {
                                                const emailOriginal = informacoesDoResponsavel.usuarioDaAreaRestrita?.email;
                                                if (emailOriginal != undefined && f.email.endereco != emailOriginal) {
                                                    v.usuarioDaAreaRestrita = {
                                                        email: f.email.endereco,
                                                    };
                                                }

                                                return v;
                                            }}
                                            privilegio={"responsavel"}
                                            notificar={false}
                                            limparFormularioAoFinalizar={false}
                                            depoisDeFinalizar={() => {
                                                const intervaloSeg = 2;

                                                let mensagem: JSX.Element = <> Informações atualizadas com sucesso. </>;

                                                notification.open({
                                                    ...PropriedadesDeNotificacao.Sucesso(mensagem),
                                                    duration: intervaloSeg,
                                                });

                                                setTimeout(() => {
                                                    window.location.reload();
                                                }, intervaloSeg * 1000);
                                            }}
                                        />
                                    </React.Fragment>
                                )}
                            </Card>
                        }
                    />

                    <Route key={"alunos"} path="/alunos" element={<AlunosScreen />} />

                    <Route
                        key="ficha-de-saude"
                        path="/ficha-de-saude"
                        element={
                            <Card>
                                <React.Fragment>
                                    <Typography.Title level={4} style={{ marginTop: 0 }}>
                                        Ficha de saúde do aluno
                                    </Typography.Title>

                                    {alunoSelecionado && (
                                        <Row>
                                            <Col xs={24} style={{ textAlign: "end" }}>
                                                <Typography.Text>{alunoSelecionado && alunoSelecionado.pessoa?.nome}</Typography.Text>
                                                <Divider type="vertical" />
                                                <Button
                                                    type="link"
                                                    style={{ padding: 0 }}
                                                    onClick={async () => {
                                                        selecionarAluno().then((v) => {
                                                            v && setAlunoSelecionado(v);
                                                        });
                                                    }}
                                                >
                                                    Trocar aluno
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}

                                    <Divider style={{ marginTop: ".5em" }} />

                                    {
                                        alunoSelecionado?.codigo ?
                                        <FichaDeSaudeDoAluno codigoDoAluno={alunoSelecionado.codigo} /> :
                                        <React.Fragment>
                                            <Button type='primary' onClick={() => {
                                                selecionarAluno().then((v) => v && setAlunoSelecionado(v))
                                            }}>Selecionar aluno</Button>
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            </Card>
                        }
                    />

                    <Route path="*" element={<Navigate to="responsavel" />} />
                </Routes>
            </Col>
        </Row>
    );
}

export default DadosCadastraisParaTipoResponsavel;